import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqItems } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" aria-labelledby="faq-title" className="border-b border-white/5 bg-ink-900" data-id="element-80" data-mp="1l9fr7944ig6u">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-81" data-mp="2e066s0x25kux">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-82" data-mp="2dy3knrz10bvh">
          FAQ
        </p>
        <h2 id="faq-title" className="mt-5 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-83" data-mp="2429w1a818rxc">
          The questions team leads actually ask.
        </h2>

        <div className="mt-12 max-w-3xl divide-y divide-white/10 border-y border-white/10" data-id="element-84" data-mp="snd5fvw79unv">
          {faqItems.map((item, index) => {
          const isOpen = openIndex === index;
          return <div key={item.question} data-id="element-85" data-mp="pizepv55v0es" data-mpi={index}>
                <h3 data-id="element-86" data-mp="pfv52i8xfcgq">
                  <button type="button" aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} onClick={() => setOpenIndex(isOpen ? null : index)} className="flex w-full items-center justify-between gap-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-87" data-mp="ugr52kq5qegv">
                    <span className="font-display text-base font-semibold text-white sm:text-lg" data-id="element-88" data-mp="biongqzxvjt3">
                      {item.question}
                    </span>
                    <span className="flex h-7 w-7 flex-none items-center justify-center rounded-md border border-white/15 text-brand" data-id="element-89" data-mp="3swk1hbesp5so">
                      {isOpen ? <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-90" data-mp="3jyi373mg4r93" /> : <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-91" data-mp="3nz21iaira0wt" />}
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-92" data-mp="1ppunekfv3hkw">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: 'easeOut'
              }} className="overflow-hidden" data-id="element-93" data-mp="1kqi3o8kaeqmj">
                      <p className="max-w-2xl pb-6 pr-10 text-sm leading-relaxed text-white/65" data-id="element-94" data-mp="23gzta49tp63o">
                        {item.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}